import classNames from 'classnames';
import { DistanceUnitFormatKey, useDistanceFormatter } from 'i18n/unitFormat';
import cellStyles from './styles.module.scss';

const DistanceUnitCell = ({
  type, values, formatAll, removeEqual, noValue, separator,
}:{
  values: Array<number | string | undefined> | number | string | undefined,
  type: DistanceUnitFormatKey,
  noValue?: I18nKeyGenerated['common'],
  separator?: string,
  formatAll?: boolean,
  removeEqual?: boolean,
}) => {
  const formatFn = useDistanceFormatter(type);
  const val = formatFn(values, separator, noValue, formatAll, removeEqual);

  return (
    <span className={classNames('h4', cellStyles.h4)}>
      <span>{val}</span>
      <div className={classNames(cellStyles.small, cellStyles.hiddenCell)}>-</div>
    </span>
  );
};

export default DistanceUnitCell;
